import { Mail, MapPin, Phone, Facebook } from "lucide-react";
import { Link } from "wouter";
import googlePartnerLogo from "@assets/image_1773657618812.webp";
import microsoftPartnerLogo from "@assets/image_1773657604580.webp";

export function Footer() {
  const logoUrl = "https://www.thecornwallseoco.co.uk/images/The%20Cornwall%20SEO%20Co.png";
  
  return (
    <footer className="bg-black text-white pt-20 pb-10">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="space-y-6">
            <img src={logoUrl} alt="The Cornwall SEO Co" width={200} height={64} className="h-16 w-auto object-contain brightness-0 invert" />
            <ul className="space-y-3 text-white/70">
              <li className="font-medium">87 Alexandra Rd</li>
              <li className="font-medium">St Austell</li>
              <li className="font-medium">Cornwall</li>
              <li className="font-medium">PL25 4QW</li>
              <li className="font-medium">01726 74161</li>
              <li className="font-medium"><a href="mailto:hello@thecornwallseoco.co.uk" className="hover:text-primary transition-colors">hello@thecornwallseoco.co.uk</a></li>
            </ul>
            <div className="flex gap-6 pt-2">
              <a href="https://www.facebook.com/thecornwallseoco/" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-primary transition-colors" title="Follow us on Facebook">
                <Facebook size={24} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold uppercase tracking-wider text-lg mb-6 text-primary">Services</h4>
            <ul className="space-y-4">
              {[
                { name: 'SEO', href: '/search-engine-optimisation.html' },
                { name: 'AI SEO', href: '/ai-seo.html' },
                { name: 'PPC Management', href: '/pay-per-click-management.html' },
                { name: 'Social Media Management', href: '/social-media-management.html' },
                { name: 'Facebook Ads', href: '/facebook-advertising.html' },
                { name: 'Web Design', href: '/web-design.html' }
              ].map((item) => (
                <li key={item.name}>
                  {item.href.startsWith('/') ? (
                    <Link href={item.href} className="text-white/70 hover:text-primary transition-colors font-bold uppercase text-sm block">
                      {item.name}
                    </Link>
                  ) : (
                    <a href={item.href} className="text-white/70 hover:text-primary transition-colors font-bold uppercase text-sm block">
                      {item.name}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold uppercase tracking-wider text-lg mb-6 text-primary">Company</h4>
            <ul className="space-y-4">
              {[
                { name: 'About Us', href: '/company.html', external: false },
                { name: 'Contact', href: '/contact.html', external: false },
                { name: 'Blog', href: 'https://www.thecornwallseoco.co.uk/blog/', external: true }
              ].map((item) => (
                <li key={item.name}>
                  {item.external ? (
                    <a href={item.href} className="text-white/70 hover:text-primary transition-colors font-bold uppercase text-sm block">
                      {item.name}
                    </a>
                  ) : (
                    <Link href={item.href} className="text-white/70 hover:text-primary transition-colors font-bold uppercase text-sm block">
                      {item.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold uppercase tracking-wider text-lg mb-6 text-primary">Partners</h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-center justify-start">
                <img src={googlePartnerLogo} alt="Google Partner" width={150} height={48} className="h-12 w-auto object-contain" />
              </div>
              <div className="flex items-center justify-start">
                <img src={microsoftPartnerLogo} alt="Microsoft Advertising Partner" width={150} height={48} className="h-12 w-auto object-contain" />
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-start gap-4">
          <div className="text-white/50 text-xs font-medium leading-relaxed max-w-2xl">
            <p className="mb-4">© 2026 The Cornwall SEO Co All rights reserved. | <Link href="/privacy-cookies-policy.html" className="text-white/70 hover:text-primary transition-colors inline-block ml-1">Privacy & Cookies Policy</Link></p>
            <p>Page1 (Europe) Ltd. T/A The Cornwall SEO Co<br />Registered office address: 4 Tregarne Terrace, St Austell, Cornwall, PL25 4BE | Registering in England, No: 06566736 | VAT No: GB 118 636 800</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
